export default "__VITE_PUBLIC_ASSET__fdec7ef4__"